import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';

@Component({
  selector: 'app-plan-package',
  templateUrl: './plan-package.component.html',
  styleUrls: ['./plan-package.component.css']
})
export class PlanPackageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; planList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search = '';
  constructor(private sharedapi: SharedService, public miscapi: MiscService) { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.loadPlanPackageList(0, this.perpage);
  }

  async loadPlanPackageList(pageIndex, perpage) {
    this.planList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search;
    this.loading = true; this.loaded = false;
    await this.miscapi.getPlanPackageList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.planList = data.data;
      } else {
        this.planList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadPlanPackageList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadPlanPackageList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.search = '';
    this.loadPlanPackageList(0, 25);
  }



}
